import { taskStatusesService } from '@/services/task-statuses.service';

const initialState = () => ({
  taskStatuses: [],
  status: {
    error: null,
    pending: true,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getTaskStatuses({ commit }) {
    commit('GET_TASK_STATUSES');
    return taskStatusesService.getTaskStatuses().then(
      (taskStatuses) => {
        commit('GET_TASK_STATUSES_SUCCESS', taskStatuses);
        return taskStatuses;
      },
      (error) => {
        commit('GET_TASK_STATUSES_ERROR', error);
        throw error;
      },
    );
  },
  RESET({ commit }) {
    commit('RESET_STORE');
  },
};

const mutations = {
  GET_TASK_STATUSES(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.taskStatuses = [];
  },
  GET_TASK_STATUSES_SUCCESS(state, taskStatuses) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.taskStatuses = taskStatuses;
  },
  GET_TASK_STATUSES_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error,
    };
    state.taskStatuses = [];
  },
  RESET_STORE(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const getters = {
  taskStatuses: (state) => state.taskStatuses,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const taskStatuses = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
